import * as Sentry from "@sentry/browser";
import endpointMaker from "configuration/endpoints";
import request from "http/request";
import store from "redux/store";

const fetchReport = ({
  query,
  signal,
}: {
  query;
  signal?: AbortSignal;
}) => {
  if (query?.select?.length === 0) {
    Sentry.captureMessage("Reporter query contains empty select", {
      level: "warning",
    });
    return Promise.reject(
      new Error("No select columns provided in reporter query")
    );
  }

  return request.post(
    endpointMaker.reporter.report(
      store.getState()?.auth?.organizationId,
      store.getState()?.auth?.accountId
    ),
    query,
    signal
  );
};

export default fetchReport;
